<template>
    <tr class="table__row" :class="{'table__row--disabled': blockOffer}">
        <td class="table__col">
            <span class="table__col-label">№</span>
            <span class="table__col-cont">{{ number }}</span>
        </td>
        <td v-if="checkUserRole('supplier') && tender?.type?.code === 'CO' && checkStatus('активный')" class="table__col">
            <span class="table__col-label">Фото или видео</span>
            <span v-if="true" class="table__col-cont">
                <UploadMedia ref="uploadMedia" :position-id="item.id" :files="item.files" @update-tender="$emit('updateTender');" :offerCOId="offerCOId"/>
            </span>
            <span v-else class="table__col-cont">
                <div class="tooltip">
                    <span class="tooltip__icon tooltip__icon--center"></span>
                    <span class="tooltip__text">Загрузить файлы/Добавить комментарий для текущего этапа можно после отправки предложения.</span>
                </div>
            </span>
        </td>
        <td class="table__col">
            <span class="table__col-label">Наименование товара, Артикул ЕТУ</span>
            <span class="table__col-cont table__col-cont--250">
                <div class="product-block">
                    <span class="product-block__name">{{ item?.product?.name }}</span>
                    <br>
                    <b class="product-block__vendor" :class="{'product-block__vendor--test': item?.product?.isTest}">{{ item?.product?.vendor || '-' }}</b>
                </div>
            </span>
        </td>
        <td class="table__col nowrap">
            <span class="table__col-label">Объем партии</span>
            <span class="table__col-cont">{{ (item?.lotSize + ' ' + item?.product?.unit?.name) || '-' }}</span>
        </td>

		<template v-if="checkUserRole('supplier')">
			<td v-if="canSendOffer" class="table__col nowrap">
				<span class="table__col-label">Подтвержденый объём</span>
				<span class="table__col-cont">
				<span v-if="stage !== activeStage">{{ item.lotSize }}</span>
                <div v-else class="value-input">
                    <InputText :placeholder="item?.product?.unit?.name" :cost="true" v-model="confirmedQuantity" />
                </div>
            </span>
			</td>
			<template v-else-if="checkStatus('активный')">
				<td class="table__col nowrap">
					<span class="table__col-label">Срок поставки<br>c</span>
					<span class="table__col-cont">{{ item?.supplyTimeFrom || '' }}</span>
				</td>
				<td class="table__col nowrap">
					<span class="table__col-label">Срок поставки<br>по</span>
					<span class="table__col-cont">{{ item?.supplyTimeTo || '' }}</span>
				</td>
			</template>
		</template>


        <!--для тендера-->
        <template v-if="tender?.type?.code === 'TN'">
            <td class="table__col">
                <span class="table__col-label">Стартовая цена</span>
                <span class="table__col-cont">
                    <div class="price-block">
                        <div class="price-block__list">
                            <div class="price-block__item">
                                <span class="price-block__item-title">Стартовая</span>
                                <span class="price-block__item-value"> {{ item?.startPrice ? `${item?.startPrice.toLocaleString('RU-ru')} ₽` : '-' }} </span>
                            </div>
                            <div v-if="item?.bestPrice" class="price-block__item">
                                <span class="price-block__item-title">Лучшая</span>
                                <span class="price-block__item-value">{{ item.stages?.[stage]?.offers[0]?.price.toLocaleString('ru-RU') || '-' }} ₽</span>
                            </div>
                            <div
								v-if="item?.lastOffer?.price"
								class="price-block__item"
								:class="+item?.lastOffer?.price > +item?.bestPrice ? 'price-block__item--non-competitive' : 'price-block__item--last-price'"
							>
                                <span class="price-block__item-title">Моя последняя</span>
                                <span class="price-block__item-value"> {{ item?.lastOffer?.price?.toLocaleString('RU-ru') }} ₽</span>
                            </div>
                        </div>
                    </div>                   
                </span>
            </td>
        </template>
        <td v-if="checkUserRole('supplier') && checkStatus('активный')" class="table__col">
            <span class="table__col-label">Валюта</span>
            <span class="table__col-cont table__col-cont--115">
				<span v-if="stage !== activeStage">{{ currenciesList?.find(el => el.exchangeRate === currency)?.name || '-'}}</span>
                <InputSelect v-else>
                    <template #select>
                        <Multiselect
                            v-model="currency"
                            :can-clear="false"
                            :canDeselect="false"
                            :label="'name'"
                            :value-prop="'exchangeRate'"
                            :options="currenciesList"/>
                    </template>
                </InputSelect>
            </span>
        </td>

        <!--для поставщика-->
        <template v-if="checkUserRole('supplier') && canSendOffer">
            <td class="table__col table__col--noindent">
                <span class="table__col-label">Предложение цены</span>
                <span class="table__col-cont">
					<span v-if="stage !== activeStage">{{ item?.bestPrice - tender?.priceStep > 0 ? `${item?.bestPrice - tender?.priceStep}` : '' }}</span>
                    <span v-else class="send">
                        <div class="send__input">
                            <InputText :placeholder="item?.bestPrice - tender?.priceStep > 0 ? `${(+item?.bestPrice - +tender?.priceStep).toFixed(2)}` : ''" :cost="true" v-model="price"/>
                        </div>
                        <div class="send__nds">
                            <div v-for="nds in ndsList" :key="nds.id" class="send__nds-item" :class="{'active': this.nds === nds.percent}" @click="setNds(nds)">{{ nds.name }}</div>
                        </div>
                    </span>

                </span>
            </td>
            <td class="table__col">
                <span class="table__col-label">Способ место, доставки, город</span>
                <span class="table__col-cont table__col-cont--100" > {{ currentDeliveryType || '-' }}
                    <button
                        v-if="deliveryTypes.length > 1 && isSelfDeliveryAllowed "
                        class="edit-link" @click="this.$emit('changeDeliveryType', item.id)">Изменить</button>
                </span>
                <br>
                <span class="table__col-cont table__col-cont--100">{{ getOffersKey({id: item.id, key: 'delivery'}) ? currentDeliveryPlace || '-' : '-' }}
                    <button v-if="deliveryPlaces.length > 1 && !showCity" class="edit-link" @click="this.$emit('changeDeliveryPlace', item.id)">Изменить</button>
                </span>
                <br>
                <template v-if="showCity">
                    <span class="table__col-cont table__col-cont--100">{{ currentDeliveryCity || '-' }}
                        <button class="edit-link" @click="this.$emit('changeDeliveryCity', item.id)">Изменить</button>
                    </span>
                </template>
            </td>
        </template>

        <!--для админа или менеджера-->
        <template v-if="!checkUserRole('supplier')">
            <template v-if="!checkStatus('утверждён')">
                <td class="table__col">
                    <span class="table__col-label">Лучший поставщик</span>
                    <button v-if="item.stages?.[stage]?.offers?.length" @click="handleOpenSupplier(item.stages?.[stage]?.offers[0]?.supplier?.id)"
                            class="table__col-cont table__col-cont--green">
                            <b>{{item.stages?.[stage]?.offers[0]?.supplier?.legalForm?.name || '' }}  {{ item.stages?.[stage]?.offers[0]?.supplier?.companyName || '-' }} </b>
                    </button>
                    <span v-else class="table__col-cont">-</span>
                </td>
            </template>
        </template>

        <td v-if="!checkUserRole('supplier')" class="table__col table__col--btn">
            <div v-if="blockOffer" class="tooltip">
                <span class="tooltip__icon"></span>
                <span class="tooltip__text">Вы не можете отправлять предложение на данный товар. Обратитесь к своему менеджеру</span>
            </div>
            <template v-if="!checkUserRole('supplier')">
                <div @click="toggleOther" class="show-more">
                    <div v-if="item.stages?.[stage]?.offers.length" class="show-more__count">+{{ item.stages?.[stage]?.offers.length }}</div>
                    <div class="show-more__btn">
                        <button class="more">Дополнительная информация</button>
                    </div>
                </div>
            </template>
        </td>
    </tr>
    <tr class="table__toggle" :class="{'table__toggle-hidden': !checkUserRole('supplier') }">
        <td colspan="100%">
            <div class="tender-info">
                <div class="tender-info__block">
                    <div class="tender-info__deadlines">
                        <div class="ti-block">
                            <div class="ti-block__left">
                                <div class="ti-block__title">Срок поставки с</div>
                                <div class="ti-block__text">{{ item?.supplyTimeFrom || '-' }} <span>Заявленный</span></div>
                            </div>
                            <div v-if="checkUserRole('supplier')" class="ti-block__right">
                                <InputDate label="Срок поставки с" :disabled="!checkStatus('активный')" placeholder="xx.xx.xxxx" v-model="supplyTimeFrom"/>
                            </div>
                        </div>
                        <div class="ti-block">
                            <div class="ti-block__left">
                                <div class="ti-block__title">Срок поставки до</div>
                                <div class="ti-block__text">{{ item?.supplyTimeTo || '-' }} <span>Заявленный</span></div>
                            </div>
                            <div  v-if="checkUserRole('supplier')" class="ti-block__right">
                                <InputDate label="Срок поставки до" :disabled="!checkStatus('активный')" placeholder="xx.xx.xxxx" v-model="supplyTimeTo"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="item?.description" class="tender-info__block">
                    <div class="tender-info__block-title">Описание товара</div>
                    <div class="tender-info__block-text">
                        {{ item?.description || '-' }}
                    </div>
                </div>
                <div v-if="checkUserRole('supplier')" class="tender-info__block">
                    <Tender-Comment ref="tenderComment" :comment="item?.comment" :position-id="item.id" :offerCOId="offerCOId" :is-tender="tender?.type?.code === 'TN'"></Tender-Comment>
                </div>
                <div v-if="checkUserRole('supplier') && checkStatus('активный') && stage === activeStage " class="tender-info__block">
                    <div class="tender-info__block-btn">
                        <div class="tender-info__block-send">
                            <button :disabled="!isFieldsFilled" class="btn btn--color" :class="{'btn--send': !isFieldsFilled}" @click="handleSubmit">Отправить предложение</button>
                            <div v-if="!isFieldsFilled" class="tooltip">
                                <span class="tooltip__icon"></span>
                                <span class="tooltip__text">Для отправки предложения необходимо заполнить все поля</span>
                            </div>
                        </div>
                        <button v-if="(checkUserRole('supplier') && checkStatus('активный')) && (tender?.type?.code === 'CO' || !item?.comment && item.lastOffer)" class="btn btn--border btn--gray" @click="this.$refs.tenderComment.showAddPopup()">Добавить комментарий</button>
                    </div>
                </div>
                <div v-if="openMoreTable && !checkUserRole('supplier') && item.stages[stage].offers.length" class="tender-info__block">
                    <div class="table__group">
                        <div class="tender-info__block-title">Все предложения</div>
                        <table v-if="item.stages[stage].offers.length" class="table-inner">
                            <thead class="table-inner__head">
                            <tr class="table-inner__row">
                                <td class="table-inner__col">Цена, валюта, НДС</td>
                                <td class="table-inner__col">Подтв. <br> объем</td>

                                <td class="table-inner__col">Поставщик</td>
                                <td class="table-inner__col">Комментарий</td>
                                <template v-if="tender?.type?.code === 'CO'">
                                    <td class="table-inner__col">Файлы</td>
                                </template>
                                <td class="table-inner__col">Способ доставки</td>
                                <td class="table-inner__col">Сроки поставки</td>
                                <td class="table-inner__col">Место доставки</td>
                                <td class="table-inner__col">Город </td>
                                <td class="table-inner__col"></td>
                            </tr>
                            </thead>
                            <tbody class="table-inner__body">
                            <tr class="table-inner__row" v-for="el in item.stages[stage].offers" :key="el.id">
                                <td class="table-inner__col">
                                    <span class="table-inner__col-label">Цена, валюта, НДС</span>
                                    <span class="table-inner__col-cont">
                                        <b>{{ el?.price?.toLocaleString('RU-ru') }}&nbsp;₽ </b> <br>
                                        {{ el?.currency?.name || '-' }} <br>
                                        {{ el?.vat?.name || '-' }}
                                    </span>
                                </td>
                                <td class="table-inner__col">
                                    <span class="table-inner__col-label">Подтвержденный объем</span>
                                    <span class="table-inner__col-cont">{{ el?.confirmedQuantity?.toLocaleString('RU-ru') || '-' }}</span>
                                </td>
                                <td class="table-inner__col">
                                    <span class="table-inner__col-label">Поставщик</span>
                                    <button v-if="el.supplier?.id" @click="handleOpenSupplier(el.supplier?.id) "
                                            class="table__col-cont " :class="{'table__col-cont--green': !checkUserRole('supplier'), 'table__col-cont--block': checkUserRole('supplier')}">
                                            <b>{{el.supplier?.legalForm?.name || '' }} {{ el.supplier?.companyName || '-' }} </b>
                                    </button>
                                    <span v-else class="table-inner__col-cont">{{el.supplier?.legalForm?.name || '' }} {{ el.supplier?.companyName || '-' }}</span>
                                </td>
                                <td  class="table-inner__col">
                                    <span class="table-inner__col-label">Комментарий</span>
                                    <span class="table__col-cont table__col-cont--350" v-hidden-text="{height: 40, title: 'Читать дальше...'}">{{ el.comment || '-' }}</span>
                                </td>
                                <td v-if="tender?.type?.code === 'CO'" class="table-inner__col">
                                    <span class="table-inner__col-label">Файлы</span>
                                    <span class="table__col-cont">
                                        <UploadMedia v-if="el.files?.length" :position-id="item.id" :files="el.files" :is-supplier="false"/>
                                        <span v-else> - </span>
                                    </span>
                                </td>
                                <td class="table-inner__col">
                                    <span class="table-inner__col-label">Способ доставки</span>
                                    <span class="table-inner__col-cont">{{ el.delivery?.name || '-' }}</span><br>
                                </td>
                                <td class="table-inner__col">
                                    <span class="table-inner__col-label">Сроки поставки</span>
                                    <span v-if="el?.supplyTimeFrom" class="table-inner__col-cont">
                                        {{ el?.supplyTimeFrom || '-' }}<br>
                                        {{ el?.supplyTimeTo || '-' }}
                                    </span>
                                    <span v-else class="table-inner__col-cont">-</span>
                                </td>
                                <td class="table-inner__col">
                                    <span class="table-inner__col-label">Место доставки</span>
                                    <span class="table-inner__col-cont">{{ el.deliveryDestination?.name || '-' }}</span><br>
                                </td>
                                <td class="table-inner__col">
                                    <span class="table-inner__col-label">Город</span>
                                    <span class="table-inner__col-cont">{{ el.city?.name || '-' }}</span>
                                </td>
                                <td v-if="checkUserRole('manager')" class="table-inner__col">
                                    <span class="table-inner__col-label">Удалить предложение</span>
                                    <span class="table-inner__col-cont">
                                        <div class="table-actions">
                                            <span class="table-actions__delete" @click="approveRemoveOffer(el.id)"></span>
                                        </div>
                                    </span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="table-inner__empty" v-else>В текущем этапе предложения от поставщиков отсутствуют</div>
                        <div class="table__toggle-hide" @click="toggleOtherMobile">Скрыть предложения</div>
                    </div>
                </div>
        </div>

        </td>

    </tr>

    <tr class="table__margin">
        <td colspan="100%"></td>
    </tr>

    <transition-group name="modal">
        <SupplierPopup v-if="ShowSupplierPopup" :supplier="selectedSupplier" :canEdit="false" @close="ShowSupplierPopup = false"/>
        <ApproveRemoveOfferPopup v-if="ShowApproveRemoveOfferPopup" :selectedOffer="selectedOffer" @refreshTenderOffers="this.refreshTenderOffers()"  @close="ShowApproveRemoveOfferPopup = false"/>
    </transition-group>

</template>

<script>
import {mapActions, mapGetters} from "vuex";

import InputText from "@/components/base/utils/formElements/InputText.vue";
import InputSelect from "@/components/base/utils/formElements/InputSelect.vue";
import Multiselect from "@vueform/multiselect/src/Multiselect";
import SupplierPopup from "@/components/sections/Suppliers/SupplierPopup.vue";
import ApproveRemoveOfferPopup from "@/components/sections/Tenders/TenderInner/ApproveRemoveOfferPopup.vue";
import TenderComment from "@/components/sections/Tenders/TenderInner/TenderComment.vue";
import UploadMedia from "@/components/sections/Tenders/TenderInner/UploadMedia.vue";
import {useToast} from "vue-toastification";
import InputDate from "@/components/base/utils/formElements/InputDate.vue";


export default {
    name: "TenderInnerTableRow",
    components: {SupplierPopup, InputText, InputSelect, Multiselect,  ApproveRemoveOfferPopup, TenderComment, UploadMedia, InputDate},
    emits: ['changeDeliveryType', 'changeDeliveryPlace', 'changeDeliveryCity', 'updateTender'],
    props: {
        item: {
            type: Object,
            required: true,
        },
        tender: {
            type: Object
        },
        deliveryTypes: {
            type: Array,
            default: () => []
        },
        deliveryPlaces: {
            type: Array,
            default: () => []
        },
        canSendOffer: {
            type: Boolean,
            default: false,
        },
        number: {
            type: Number,
            default: 0,
        },
        stage: {
            type: [Number, String]
        },
        activeStage: {
            type: [Number, String]
        }
    },

    data() {
        return {
            toast: useToast(),
            selectedSupplier: null,
            selectedOffer: null,
            ShowSupplierPopup: false,
            ShowApproveRemoveOfferPopup: false,
            offerWasSend: false,
            oldPrice: null,
            nds: Number(sessionStorage.getItem('nds')) || 0,
            currency: 1,
            confirmedQuantity: '',
            openMoreTable: false,
            offerCOId: 0,
			supplyTimeFrom: [''],
			supplyTimeTo: [''],
        }
    },
    watch: {
        showCity() {
            if (this.getOffersKey({id: this.item.id, key: 'useRate'})) {
                const el = this.deliveryPlaces.find(el => el.useDistrCenters);
                this.updateOffersKey({id: this.item.id, key: 'deliveryDestination', value: el?.id});

                const lastCity = this.item.lastOffer?.city?.id;
                const hasCity = this.getOffersKey({id: this.item.id, key: 'city'});

                if (lastCity && !hasCity) {
                    this.updateOffersKey({id: this.item.id, key: 'city', value: lastCity})
                }
            }
        }
    },
    computed: {
        isSelfDeliveryAllowed() {
            return this.item?.product?.unit?.allowSelfDelivery
        },
        showPriceTooltip() {
            if (this.getOffersKey({id: this.item.id, key: 'useRate'})) {
                return (Number(this.item?.lastOffer?.price) !== Number(this.price) && this.offerWasSend)
            } else {
                return false
            }
        },
        blockOffer() {
            if (!this.checkUserRole('supplier')) return false
            return this.item.canMakeOffer === false
        },
        showCity() {
            return this.getOffersKey({id: this.item.id, key: 'useRate'});
        },
        price: {
            get() {
                return this.getOffersKey({id: this.item.id, key: 'price'});
            },
            set(value) {
                this.offerWasSend = false
                this.updateOffersKey({id: this.item.id, key: 'price', value: value.replace(/\s/g, '')})
            }
        },
        currentDeliveryType() {
            const index = this.deliveryTypes.findIndex(el => el.id === this.getOffersKey({
                id: this.item.id,
                key: 'delivery'
            }));
            return this.deliveryTypes[index]?.name || '-'
        },
        currentDeliveryPlace() {
            const index = this.deliveryPlaces.findIndex(el => el.id === this.getOffersKey({
                id: this.item.id,
                key: 'deliveryDestination'
            }));
            return this.deliveryPlaces[index]?.name || '-'
        },
        currentDeliveryCity() {
            const index = this.getCities.findIndex(el => el.id === this.getOffersKey({id: this.item.id, key: 'city'}));
            return this.getCities[index]?.name || '-'
        },
        isFieldsFilled() {
            if (this.showCity) {
                return this.price && this.currentDeliveryType && this.currentDeliveryCity && this.confirmedQuantity && this.supplyTimeFrom[0] && this.supplyTimeTo[0]
            } else {
                return this.price && this.currentDeliveryType && this.currentDeliveryPlace && this.confirmedQuantity && this.supplyTimeFrom[0] && this.supplyTimeTo[0]
            }
        },
        ...mapGetters({
            getOffersKey: 'tenders/getOffersKey',
            getCities: 'delivery/getCities',
            checkUserRole: 'user/checkUserRole',
            ndsList: 'tenders/getNdsList',
            currenciesList: 'tenders/getCurrenciesList',
        })
    },
    mounted() {
        if (this.item?.product?.unit && !this.item.product.unit.allowSelfDelivery) {
            const el = this.deliveryTypes.find(el => !el.useRate);
            this.updateOffersKey({id: this.item.id, key: 'delivery', value: el?.id});
        }

        //Если КП и оффер уже есть
        const isCOandBlocked = this.tender?.type?.code === 'CO' && this.item?.lastOffer?.price;
        if (isCOandBlocked) {
            this.updateOffersKey({id: this.item.id, key: 'price', value: this.item.lastOffer.price})
            this.updateOffersKey({id: this.item.id, key: 'delivery', value: this.item.lastOffer.delivery?.id || null})
            this.updateOffersKey({id: this.item.id, key: 'deliveryDestination', value: this.item.lastOffer.deliveryDestination?.id || null})
            this.updateOffersKey({id: this.item.id, key: 'city', value: this.item.lastOffer.city || null})
        }
    },
    methods: {
		getLocaleDateAndTime(value) {
            if(!value) return null
			return new Date(value).toLocaleDateString('ru-RU');
		},
      checkStatus(status) {
        return this.tender?.status?.name?.toLowerCase() === status;
      },
        toggleOther(e) {
            let parentTable = e.target.closest('.table__row')
            parentTable.nextElementSibling.classList.toggle('table__toggle-hidden')
            parentTable.classList.toggle('table__row--open')
            this.openMoreTable = !this.openMoreTable
        },
        toggleOtherMobile(e) {
            let parentTable = e.target.closest('.table__toggle')
            parentTable.classList.toggle('table__toggle-hidden')
            parentTable.previousElementSibling.classList.toggle('table__row--open')
        },
        async handleOpenSupplier(id = "") {
            if (!id) return
            const res = await this.requestSupplier(id);

            if (res.success) {
                this.selectedSupplier = res.data;
                this.ShowSupplierPopup = true;
            }
        },
        async approveRemoveOffer(id) {
            if(!id) return
            this.selectedOffer = id
            this.ShowApproveRemoveOfferPopup = true;
        },

        refreshTenderOffers() {
            // eslint-disable-next-line
            this.item.offers = this.item.offers.filter((item)=> item.id !== this.selectedOffer)
        },

        setNds(nds) {
            this.nds = nds.percent
            if(sessionStorage.getItem('nds') !== nds.percent) {
                sessionStorage.setItem('nds', nds.percent)
            }
        },
        calculatePrice() {
            const currencyRate = this.price * (this.currency || 1)
            const ndsRate = (currencyRate / 100) * this.nds
            return currencyRate + ndsRate
        },

        async handleSubmit() {

            const data = {
                position: this.item.id,
                price: this.calculatePrice(),
                delivery: this.getOffersKey({id: this.item.id, key: 'delivery'}),
                vat: this.ndsList.find(el => el.percent === this.nds)?.id,
                currency: this.currenciesList.find(el => el.exchangeRate === this.currency)?.id,
                confirmedQuantity: this.confirmedQuantity.replace(/\s/g, ""),
				supplyTimeFrom: this.getLocaleDateAndTime(this.supplyTimeFrom[0] || ''),
				supplyTimeTo: this.getLocaleDateAndTime(this.supplyTimeTo[0] || ''),
            };

            if (this.showCity) {
                data.city = this.getOffersKey({id: this.item.id, key: 'city'})
                data.deliveryDestination = this.tender.deliveryDestinations?.find(el => el.useDistrCenters)?.id || null
            } else {
                data.deliveryDestination = this.getOffersKey({id: this.item.id, key: 'deliveryDestination'})
            }

            const res = await this.requestMakeTenderOffer(data);
            if (res.success) {
                this.toast.success('Предложение успешно отправлено.');
                this.offerWasSend = true;
                this.oldPrice = this.price;
                if (this.tender?.type?.code === 'TN') {
                    await this.updateOffersKey({id: this.item.id, key: 'price', value: null})
                } else {
                    this.offerCOId = res.data
                    setTimeout(() =>  {
                        this.$refs.uploadMedia.sendForm()
                        this.$refs.tenderComment.sendForm()
                    }, 500)
                }
                this.$emit('updateTender');
            }
        },
        ...mapActions({
            updateOffersKey: 'tenders/updateOffersKey',
            requestSupplier: 'suppliers/requestSupplier',
            requestMakeTenderOffer: 'tenders/requestMakeTenderOffer',
        })
    },
}
</script>


